const CareKeyRelatedView = () => {
  // Cases still relate to waivers in the database, so the waiver needs a (blank) embedded view.
  return <></>
}

export default CareKeyRelatedView
